import { APIEndpoints } from "../../constants";
import {
  APIPost,
  APIPostFormData,
  getAuthHeaders,
  getAuthFormDataHeaders,
  APIResponse,
} from "../api/common.service";
import {
  CreateAnnouncementRequest,
  CreateAnnouncementResponseData,
  EditAnnouncementRequest,
  EditAnnouncementResponseData,
  COQLRequest,
  AnnouncementSearchResponseData,
} from "../../types";
import { buildWorkdriveFormData } from "../../utils/workdrive.utils";

export function CreateAnnouncement(
  body: CreateAnnouncementRequest,
): Promise<APIResponse<CreateAnnouncementResponseData>> {
  const formData = buildWorkdriveFormData(
    body.module,
    body.fields,
    body.trigger,
    body.file ? [body.file] : undefined,
  );

  return getAuthFormDataHeaders().then((headers) =>
    APIPostFormData<CreateAnnouncementResponseData>(
      APIEndpoints.CreateAnnouncement,
      headers,
      formData,
    ),
  );
}

export function EditAnnouncement(
  body: EditAnnouncementRequest,
  options?: { skipLoader?: boolean },
): Promise<APIResponse<EditAnnouncementResponseData>> {
  if (body.file) {
    const formData = buildWorkdriveFormData(
      body.module,
      body.fields,
      body.trigger,
      [body.file],
    );

    return getAuthFormDataHeaders().then((headers) =>
      APIPostFormData<EditAnnouncementResponseData>(
        `${APIEndpoints.CreateAnnouncement}/${encodeURIComponent(body.recordId)}/edit`,
        headers,
        formData,
      ),
    );
  }

  return getAuthHeaders().then((headers) =>
    APIPost<EditAnnouncementResponseData>(
      APIEndpoints.EditAnnouncement,
      headers,
      undefined,
      body as unknown as Record<string, unknown>,
      options,
    ),
  );
}

export function SearchAnnouncements(
  body: COQLRequest,
  options?: { skipLoader?: boolean },
): Promise<APIResponse<AnnouncementSearchResponseData>> {
  return getAuthHeaders().then((headers) =>
    APIPost<AnnouncementSearchResponseData>(
      APIEndpoints.SearchAnnouncements,
      headers,
      undefined,
      body as unknown as Record<string, unknown>,
      options,
    ),
  );
}
